import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { App } from "./site";
import { initializeGrowthAnalytics } from "./analytics";
import { MetaTrackingChoice } from "./meta-consent";

initializeGrowthAnalytics();

createRoot(document.getElementById("root")!).render(
  <StrictMode><App /><MetaTrackingChoice /></StrictMode>,
);
